import {
  HttpErrorResponse,
  HttpHandlerFn,
  HttpInterceptorFn,
  HttpRequest,
} from "@angular/common/http";
import { inject } from "@angular/core";
import { LocalStorageJwtService } from "../services/token-storage/local-storage-jwt.service";
import { PlayerSessionService } from "../services/player-session/player-session.service";
import { ApiURL } from "../tokens";
import { catchError, switchMap, throwError } from "rxjs";

export const tokenInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const apiUrl = inject(ApiURL);
  const storage = inject(LocalStorageJwtService);
  const playerSession = inject(PlayerSessionService);

  if (!req.url.includes(apiUrl)) return next(req);

  const withToken = (token: string | null) =>
    token ? req.clone({ headers: req.headers.set("Authorization", `Bearer ${token}`) }) : req;

  return playerSession.ensureValidSession().pipe(
    switchMap((sessionToken) => {
      const bootstrap = storage.getItemSync();
      const selectedToken = sessionToken ?? (bootstrap?.isValid() ? bootstrap.toString() : null);
      return next(withToken(selectedToken)).pipe(
        catchError((error: unknown) => {
          if (!(error instanceof HttpErrorResponse) || error.status !== 401 || !sessionToken) {
            return throwError(() => error);
          }
          const currentSessionToken = playerSession.currentAccessToken();
          if (currentSessionToken && currentSessionToken !== sessionToken) {
            return next(withToken(currentSessionToken));
          }
          return playerSession.ensureValidSession(true).pipe(
            switchMap((renewed) => {
              const currentBootstrap = storage.getItemSync();
              const retryToken =
                renewed ?? (currentBootstrap?.isValid() ? currentBootstrap.toString() : null);
              return next(withToken(retryToken));
            }),
          );
        }),
      );
    }),
  );
};
